// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"749":"041e9d9c944dfa47","760":"76c73b5277071dd9","1210":"045c3591c1bf89fd","2548":"ce4c5e70b447b732","6734":"ff08f565e3f6e372","9136":"f41982c30ff14832","9220":"2196fe661e42dc03"}[chunkId] + ".js";
};